export enum VoucherStatus {
  Draft = 'Draft',
  PendingAudit = 'PendingAudit', // Submitted
  PendingApproval = 'PendingApproval', // Audited
  PendingCertification = 'PendingCertification', // Approved
  PendingSync = 'PendingSync', // Certified
  Synced = 'Synced', // Synced
  Deleted = 'Deleted',
  Cancelled = 'Cancelled',
}

export enum VoucherType {
  Expenditure = 'Expenditure',
  Income = 'Income',
  Transfer = 'Transfer',
}

export enum VoucherAction {
  Create = 'Create',
  ViewInTransactions = 'ViewInTransactions',
  AddTransactions = 'AddTransactions',
  RemoveTransactions = 'RemoveTransactions',
  EditTransactions = 'EditTransactions',
  EditAllFields = 'EditAllFields',
  EditDirectoriteOffice = 'EditDirectoriteOffice',
  AddComment = 'AddComment',
  Rework = 'Rework',
  Revert = 'Revert',
  Submit = 'Submit',
  Audit = 'Audit',
  Approve = 'Approve',
  Certify = 'Certify',
  Sync = 'Sync',
  DownloadPdf = 'DownloadPdf',
  Delete = 'Delete',
  Cancel = 'Cancel',
}

export enum VoucherEventType {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',
  AddTransaction = 'AddTransaction',
  EditTransactionMetadata = 'EditTransactionMetadata',
  RemoveTransaction = 'RemoveTransaction',
  AddComment = 'AddComment',
  Submit = 'Submit',
  Audit = 'Audit',
  Approve = 'Approve',
  Certify = 'Certify',
  Rework = 'Rework',
  Revert = 'Revert',
  Export = 'Export',
  Sync = 'Sync',
  SyncSuccess = 'SyncSuccess',
  SyncFailure = 'SyncFailure',
  Cancel = 'Cancel',
  CancelSyncSuccess = 'CancelSyncSuccess',
  CancelSyncFailure = 'CancelSyncFailure',
}

export enum VoucherSyncStatus {
  Unsynced = 'Unsynced',
  InProgress = 'InProgress',
  Success = 'Success',
  Failure = 'Failure',
}
